import {PlanbordQueryParameters} from '@/types/types';

export class PlanbordQueryFilter {
    private static readonly allowedQueryParameters: (keyof PlanbordQueryParameters)[] = ['tenant', 'rosterId', 'startDate', 'shownDays'];

    public static getFiltered(urlSearchParameters?: URLSearchParams): PlanbordQueryParameters {
        urlSearchParameters ??= new URLSearchParams(window.location.search);
        const result: PlanbordQueryParameters = {};

        PlanbordQueryFilter.allowedQueryParameters.forEach((key: keyof PlanbordQueryParameters): void => {
            if (urlSearchParameters.has(key)) {
                result[key] = urlSearchParameters.get(key)!;
            }
        });

        return result;
    }

    public static setFiltered(urlSearchParameters: URLSearchParams, planbordQueryParameters: PlanbordQueryParameters): void {
        let key: keyof PlanbordQueryParameters;
        for (key in planbordQueryParameters) {
            const value: string | undefined = planbordQueryParameters[key];
            if (value !== undefined) {
                urlSearchParameters.set(key, value);
            }
        }
    }

    public static getFromState(urlSearchParameters: URLSearchParams): PlanbordQueryParameters {
        const state: string | null = urlSearchParameters.get('state');
        if (state === null) {
            return {};
        }

        return PlanbordQueryFilter.getFiltered(new URLSearchParams(JSON.parse(state)));
    }
}
